<template>
  <validation-observer ref="validator" v-slot="{ invalid, handleSubmit }" tag="div">
    <t-form @submit.native.prevent="handleSubmit(submit)">
      <validation-provider
        v-slot="{ errors }"
        vid="label"
        :name="$t('fields.document_label')"
        rules="required"
      >
        <t-form-element>
          <t-form-label>{{ $t('fields.document_label') }}</t-form-label>
          <t-input v-model="form.label" />
          <span v-if="errors" class="text--danger">{{ errors[0] }}</span>
        </t-form-element>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        vid="file"
        :name="$t('fields.file')"
        rules="required"
      >
        <t-form-element>
          <t-form-label>{{ $t('fields.document_file') }}</t-form-label>
          <t-file-upload
            v-model="form.file"
            class="file-upload"
            accept="image/jpg,image/png,application/pdf"
          />
          <p class="text--grey">{{ $t('hints.document_file_upload') }}</p>
          <span v-if="errors" class="text--danger">{{ errors[0] }}</span>
        </t-form-element>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        vid="document_upload_terms"
        :name="$t('fields.document_upload_terms')"
        :rules="{ required: { allowFalse: false } }"
      >
        <t-checkbox v-model="form.terms_accepted">
          {{ $t('fields.document_upload_terms_accept') }}
        </t-checkbox>
        <span v-if="errors" class="text--danger">{{ errors[0] }}</span>
      </validation-provider>

      <t-form-element>
        <t-button-loading native-type="submit" :loading="loading" :disabled="invalid">
          {{ $t('global.actions.save') }}
        </t-button-loading>
      </t-form-element>
    </t-form>
  </validation-observer>
</template>

<script>
import Vue from 'vue';
import TFormCard from '~/components/TFormCard.vue';

export default Vue.extend({
  components: { TFormCard },

  props: {
    form: {
      type: Object,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  methods: {
    async submit() {
      this.$emit('submit');
    },
  },
});
</script>

<style lang="scss" scoped>
.file-upload {
  margin-top: $s-2;
  ::v-deep > div {
    width: 100%;
  }
}
</style>
